<template>
  <vs-row vs-justify="center">
    <b-loading :is-full-page="true" v-model="isLoading"/>
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-row>
        <!-- Inicio Panel FILTRO -->
        <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
          <vs-card>
            <!-- Titulo de panel -->
            <div slot="header">
              <h3 class="card-title mb-0">Configuración datos externo</h3>
            </div>
            <vs-row>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <CompanySelector v-model="selectedCompany"/>
              </vs-col>
              <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
                <label class="vs-input--label">Proveedor *</label>
                <vs-select class="w-100" v-model="setting.supplier">
                  <vs-select-item
                      v-for="(item,index) in suppliers"
                      :key="index"
                      :value="item"
                      :text="item"/>
                </vs-select>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Url *</label>
                <vs-input type="text" v-model="setting.url" class="w-100 "/>
              </vs-col>
            </vs-row>
            <vs-row class="w-100 mt-2">
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Usuario *</label>
                <vs-input type="text" v-model="setting.username" class="w-100 "/>
              </vs-col>
              <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
                <label class="vs-input--label">Clave *</label>
                <vs-input type="text" v-model="setting.password" class="w-100 "/>
              </vs-col>
              <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
                <label class="vs-input--label">Cliente Id </label>
                <vs-input type="text" v-model="setting.clientId" class="w-100 "/>
              </vs-col>

            </vs-row>
            <vs-row class="w-100 mt-2">
              <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
                <label class="vs-input--label">Estado *</label>
                <vs-select class="w-100" v-model="setting.status">
                  <vs-select-item
                      v-for="(item,index) in statusList"
                      :key="index"
                      :value="item.value"
                      :text="item.text"/>
                </vs-select>
              </vs-col>
              <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
                <label class="vs-input--label">Punto de atención</label>
                <vs-input type="text" v-model="attentionPointId" class="w-100 "/>
              </vs-col>
              <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
                <label class="vs-input--label">Proveedor Id</label>
                <vs-input type="text" v-model="serviceProviderId" class="w-100 "/>
              </vs-col>
            </vs-row>
            <vs-row class="w-100 mt-2">
              <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
                <label class="vs-input--label">Forma de pago *</label>
                <vs-select class="w-100" v-model="setting.method">
                  <vs-select-item
                      v-for="(method, index) in payMethods"
                      :key="index"
                      :value="method.id"
                      :text="method.label"/>
                </vs-select>
              </vs-col>
            </vs-row>
            <hr class="custom-hr"/>
            <div class="d-inline-block d-md-flex align-items-center">
              <div class="btn-alignment">
                <vs-button @click="save">Guardar</vs-button>
              </div>
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
    </vs-col>
  </vs-row>
</template>
<script>
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import CompanySelector from "@/components/Shared/CompanySelector";
import {clear} from '@/global/utils';
import toast from "@/global/ToastConfig";
import externalSettingEndpoint from "@/endpoints/external/ExternalSettingEndpoint";
import globalEndpoint from "@/endpoints/core/GlobalEndpoint";
import kind from "@/global/lasting/EKind";

export default {
  name: "ExternalSetting",
  components: {
    CompanySelector
  },
  data: () => ({
    suppliers: ['FLYPASS'],
    statusList: [
      {value: 'ACTIVE', text: 'Activo'},
      {value: 'INACTIVE', text: 'Inactivo'},
      {value: 'PENDING', text: 'Pendiente'},
    ],
    selectedCompany: null,
    isLoading: false,
    attentionPointId: null,
    serviceProviderId: null,
    setting: {
      id: null,
      company: {code: null},
      password: null,
      username: null,
      clientId: null,
      supplier: null,
      url: null,
      status: 'ACTIVE',
      info: null,
      method: null,
    },
    method: null,
    payMethods: [],

  }),

  mounted() {
    globalEndpoint.getUnityListByKinds(kind.WAY_PAY, "método de pago")
        .then((info) => this.payMethods = info);
  },
  watch: {
    selectedCompany() {
      if (this.selectedCompany) {
        clear(this.setting);
        this.isLoading = true;
        externalSettingEndpoint.findByCompany(this.selectedCompany)
            .then(setting => {
              Object.assign(this.setting, setting);
              this.isLoading = false;
              this.updateAttentionPointAndServiceProvider();
            });
      }
    },
    'setting.supplier': function (newSupplier) {
      this.updateAttentionPointAndServiceProvider();
    }
  },
  methods: {
    updateAttentionPointAndServiceProvider() {
      if (!this.canProcessSetting()) {
        this.resetAttentionPointAndServiceProvider();
        return;
      }
      const parsedSetting = this.parseSettingInfo();
      const supplierKey = this.getSupplierKey();
      if (parsedSetting && parsedSetting[supplierKey]) {
        this.assignAttentionPointAndServiceProvider(parsedSetting[supplierKey]);
        return;
      }
      this.resetAttentionPointAndServiceProvider();
    },
    resetAttentionPointAndServiceProvider() {
      this.attentionPointId = null;
      this.serviceProviderId = null;
    },
    assignAttentionPointAndServiceProvider(supplierInfo) {
      this.attentionPointId = supplierInfo.attentionPointId || null;
      this.serviceProviderId = supplierInfo.serviceProviderId || null;
    },
    getSupplierKey() {
      return this.setting.supplier.toLowerCase();
    },
    canProcessSetting() {
      return this.setting.supplier && this.setting.info;
    },
    parseSettingInfo() {
      try {
        return JSON.parse(this.setting.info);
      } catch (error) {
        console.error("Error parsing 'info':", error);
        return null;
      }
    },
    validate() {
      if (!this.selectedCompany) {
        throw new Error("Debe seleccionar una empresa");
      }
      if (!this.setting.supplier) {
        throw new Error("Debe agregar un proveedor");
      }
      if (!this.setting.url) {
        throw new Error("Debe agregar una url");
      }
      if (!this.setting.username) {
        throw new Error("Debe agregar un usuario");
      }
      if (!this.setting.password) {
        throw new Error("Debe agregar una clave");
      }
      if (!this.setting.method) {
        throw  new Error("Debe seleccionar un método de pago");
      }
    },
    buildInfo() {
      const attentionPointId = this.attentionPointId ? parseInt(this.attentionPointId) : 0;
      const serviceProviderId = this.serviceProviderId ? parseInt(this.serviceProviderId) : 0;
      const infoObject = {
        [this.setting.supplier.toLowerCase()]: {
          attentionPointId: attentionPointId,
          serviceProviderId: serviceProviderId
        }
      };
      this.setting.info = JSON.stringify(infoObject);
    },
    save() {
      try {
        this.validate();
        this.buildInfo();
        this.isLoading = true;
        this.setting.company = this.selectedCompany;
        externalSettingEndpoint.save(this.setting)
            .then(() => (this.selectedCompany = null) || clear(this.setting))
            .finally(() => this.isLoading = false);
      } catch (error) {
        toast.error(error.message);
      }
    }
  }
};
</script>
<style>
</style>
